import Vue from "vue";
import Router from "vue-router";

// Auth
const AuthContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "auth-container" */ "@/app/views/auth-view/containers/auth-container/auth-container.vue"
    );
const AuthPassword = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "auth-password" */ "@/app/views/auth-view/components/auth-password/auth-password.vue"
    );
const AuthLogin = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "auth-login" */ "@/app/views/auth-view/components/auth-login/auth-login.vue"
    );

// Main
const MainView = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "main-view" */ "@/app/views/main-view/main-view.vue");
const DashboardContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dashboard-container" */ "@/app/views/main-view/dashboard/containers/dashboard-container/dashboard-container.vue"
    );
const UsersContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "users-container" */ "@/app/views/main-view/users/containers/users-container/users-container.vue"
    );

const StoreCreditListContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "store-credit-list-container" */ "@/app/views/main-view/users/containers/store-credit-list-container/store-credit-list-container.vue"
    );

// Users
const UsersView = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "users-view" */ "@/app/views/main-view/users/users-view.vue");
const UserViewComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "user-view-component" */ "@/app/views/main-view/users/components/user-view-component/user-view-component.vue"
    );
const WalkerSitterComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "walker-sitter-component" */ "@/app/views/main-view/users/components/walker-sitter-component/walker-sitter-component.vue"
    );

// Brands
const BrandsView = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "brands-view" */ "@/app/views/main-view/brands/brands-view.vue");
const BrandsContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "brands-container" */ "@/app/views/main-view/brands/containers/brands-container/brands-container.vue"
    );

// Products
const ProductsView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "products-view" */ "@/app/views/main-view/products/products-view.vue"
    );
const ProductsContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "products-container" */ "@/app/views/main-view/products/containers/products-container/products-container.vue"
    );
const AddEditProductComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "add-edit-product-component" */ "@/app/views/main-view/products/components/product-add-edit-component/product-add-edit-component.vue"
    );

// Bundles
const BundlesView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "bundles-view" */ "@/app/views/main-view/bundles/bundles-view.vue"
    );
const BundlesContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "bundles-container" */ "@/app/views/main-view/bundles/containers/bundles-container/bundles-container.vue"
    );
const AddEditBundleComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "add-edit-bundle-component" */ "@/app/views/main-view/bundles/components/bundle-add-edit-component/bundle-add-edit-component.vue"
    );

// Tracking
const TrackingContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "tracking-container" */ "@/app/views/main-view/tracking/containers/tracking-container/tracking-container.vue"
    );
const TrackDeviceContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "track-device-component" */ "@/app/views/main-view/tracking/containers/track-device-container/track-device-container.vue"
    );
const AuditTrailContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "audit-trail-container" */ "@/app/views/main-view/audit-trail/containers/audit-trail-container/audit-trail-container.vue"
    );

// Social
const SocialView = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "social-view"*/ "@/app/views/main-view/social/social-view.vue");
const SocialClubContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "social-clubs-container"*/ "@/app/views/main-view/social/containers/social-clubs-container/social-clubs-container.vue"
    );
const SocialClubUsersContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "social-club-users-container" */ "@/app/views/main-view/social/containers/social-club-users-container/social-club-users-container.vue"
    );
const SocialViewClubContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "social-clubs-view-container"*/ "@/app/views/main-view/social/containers/social-view-club-container/social-view-club-container.vue"
    );

// Orders
const OrdersView = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "orders-view"*/ "@/app/views/main-view/orders/orders-view.vue");
const OrdersContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "orders-container"*/ "@/app/views/main-view/orders/containers/orders-container/orders-container.vue"
    );
const OrdersDetailsContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "order-details-container"*/ "@/app/views/main-view/orders/containers/order-details-container/order-details-container.vue"
    );
const OrdersPendingContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "orders-pending-container"*/ "@/app/views/main-view/orders/containers/orders-pending-container/orders-pending-container.vue"
    );

// Notifications
const NotificationsView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "notifications-view"*/ "@/app/views/main-view/notifications/notification-view.vue"
    );
const NotificationContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "notification-container"*/ "@/app/views/main-view/notifications/containers/notification-container/notification-container.vue"
    );
const NotificationSendComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "notification-send"*/ "@/app/views/main-view/notifications/components/notification-send-component/notification-send-component.vue"
    );
const AdminNotificationContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "admin-notification-container"*/ "@/app/views/main-view/notifications/containers/admin-notification-container/admin-notification-container.vue"
    );

// Subscriptions
const SubscriptionView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "subscriptions-view"*/ "@/app/views/main-view/subscriptions/subscriptions-view.vue"
    );
const SubscriptionsManagementContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "subscriptions-management-container"*/ "@/app/views/main-view/subscriptions/container/subscriptions-management-container/subscriptions-management-container.vue"
    );

const SubscriptionDetailsPageContainer = () => import(/* webpackPrefetch: true, webpackChunkName: "subscriptions-details-page"*/ "@/app/views/main-view/subscriptions/container/subscription-details-page/subscription-details-page.vue");

// Treatments
const TreatmentsView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "treatments-view"*/ "@/app/views/main-view/treatments/treatments-view.vue"
    );
const TreatmentsManagementContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "treatments-management-container"*/ "@/app/views/main-view/treatments/container/treatments-management-container/treatments-management-container.vue"
    );

// Dog Purchase
const DogPurchaseView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-purchase-view" */ "@/app/views/main-view/dog-purchase/dog-purchase-view.vue"
    );
const DogPurchaseContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-purchase-container" */ "@/app/views/main-view/dog-purchase/containers/dog-purchase-container/dog-purchase-container.vue"
    );
const DogPurchaseDetails = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-purchase-container" */ "@/app/views/main-view/dog-purchase/containers/dog-purchase-details/dog-purchase-details.vue"
    );

//Dog Request Orders
const DogRequestOrdersView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-request-orders-view" */ "@/app/views/main-view/dog-request-orders/dog-request-orders-view.vue"
    );
const DogRequestOrdersContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-request-orders-container" */ "@/app/views/main-view/dog-request-orders/containers/dog-request-orders-container/dog-request-orders-container.vue"
    );
const DogRequestDetails = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-request-details" */ "@/app/views/main-view/dog-request-orders/containers/dog-request-details/dog-request-details.vue"
    );

// Dog Orders
const DogOrdersView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-orders-view"*/ "@/app/views/main-view/dog-orders/orders-view.vue"
    );
const DogOrdersContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-orders-container"*/ "@/app/views/main-view/dog-orders/containers/orders-container/orders-container.vue"
    );
const DogPendingOrdersContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-orders-container"*/ "@/app/views/main-view/dog-orders/containers/pending-orders-container/pending-orders-container.vue"
    );
const DogOrdersDetailsContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "dog-orders-container"*/ "@/app/views/main-view/dog-orders/containers/orders-details-container/orders-details-container.vue"
    );

// Breed Management
const BreedsView = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "breeds-view"*/ "@/app/views/main-view/breeds/breeds-view.vue");
const BreedsContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeds-container"*/ "@/app/views/main-view/breeds/containers/breeds-container/breeds-container.vue"
    );
const BreedAddEditComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breed-add-edit-component"*/ "@/app/views/main-view/breeds/components/breed-add-edit-component/breed-add-edit-component.vue"
    );

// Orders
const PuppySellingView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "puppy-selling-view"*/ "@/app/views/main-view/puppy-selling/puppy-selling-view.vue"
    );
const PuppySellingListContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "puppy-selling-list-container"*/ "@/app/views/main-view/puppy-selling/containers/puppy-selling-list-container/puppy-selling-list-container.vue"
    );
const PuppySellingDetailsContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "puppy-selling-details-container"*/ "@/app/views/main-view/puppy-selling/containers/puppy-selling-details-container/puppy-selling-details-container.vue"
    );

const PuppyPaymentListContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "puppy-payment-list-container"*/ "@/app/views/main-view/puppy-selling/containers/puppy-payment-list-container/puppy-payment-list-container.vue"
    );
const BreederUpdatePuppyPaymentContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeder-update-puppy-payment-container"*/ "@/app/views/main-view/puppy-selling/containers/breeder-update-puppy-payment-container/breeder-update-puppy-payment-container.vue"
    );


// Breed Management
const BreedersView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeders-view"*/ "@/app/views/main-view/breeders/breeders-view.vue"
    );
const BreedersContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeders-container"*/ "@/app/views/main-view/breeders/containers/breeders-container/breeders-container.vue"
    );
const BreederDetailsContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeder-details-container"*/ "@/app/views/main-view/breeders/containers/breeder-details-container/breeder-details-container.vue"
    );
const BreederAddContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeder-add-container"*/ "@/app/views/main-view/breeders/components/breeder-add-component/breeder-add-component.vue"
    );
const BreederBioFormContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeder-bio-form-container"*/ "@/app/views/main-view/breeders/components/breeder-bio-form-container/breeder-bio-form-container.vue"
    );

const BatchProductContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "batch-products-container" */ "@/app/views/main-view/products/containers/batch-products-container/batch-products-container.vue"
    );

const BreederDamSireDetails = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeder-dam-sire-details" */ "@/app/views/main-view/breeders/components/breeder-dam-sire-details/breeder-dam-sire-details.vue"
    );

const BreederDamSireDocuments = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeder-dam-sire-documents" */ "@/app/views/main-view/breeders/components/breeder-dam-sire-documents-container/breeder-dam-sire-documents-container.vue"
    );

const BreederMatingDetails = () =>
    import(
            /* webpackPrefetch: true, webpackChunkName: "breeder-matingdetails" */ "@/app/views/main-view/breeders/components/breeder-mating-details-component/breeder-mating-details-component.vue"
    );

const LitterPuppyListDetails = () =>
    import(
                /* webpackPrefetch: true, webpackChunkName: "litter-puppy-list-details" */ "@/app/views/main-view/breeders/components/breeder-litter-list-component/breeder-litter-list-component.vue"
    );

const BreederEditLitterComponent= () =>
    import(
                /* webpackPrefetch: true, webpackChunkName: "breeder-edit-litter-component" */ "@/app/views/main-view/breeders/components/breeder-edit-litter-component/breeder-edit-litter-component.vue"
    );
const BreederGestationPeriodContainer = () =>
        import(
                /* webpackPrefetch: true, webpackChunkName: "breeder-gestation-period" */ "@/app/views/main-view/breeders/components/breeder-gestation-period/containers/gestation-period-container/gestation-period-container.vue"
        );

// Pet Purchases
const PetPurchasesView = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "pet-purchases-view"*/ "@/app/views/main-view/pet-purchases/pet-purchases-view.vue"
    );

// Error
const ErrorView = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "error-view" */ "@/app/views/error-view/error-view.vue");

Vue.use(Router);
const rootTitle = "Love My Dog Club | Admin";
const scrollBehavior = (to, from, savedPosition) => {
    // Scroll to Top
    document.getElementById("app").scrollTo(0, 0);
};

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior,
    routes: [
        // auth
        {
            path: "/",
            component: AuthContainer,
            meta: { title: `${rootTitle} - Welcome` },
            redirect: "/login",
            children: [
                {
                    path: "/authenticate",
                    name: "Auth Password",
                    component: AuthPassword,
                    meta: {
                        title: `${rootTitle} - Authenticate`,
                        isAuthRequired: false,
                        isPasswordRequired: false,
                    },
                },
                {
                    path: "/login",
                    name: "Auth Login",
                    component: AuthLogin,
                    meta: {
                        title: `${rootTitle} - Login`,
                        isAuthRequired: false,
                        isPasswordRequired: true,
                    },
                },
            ],
        },
        // main
        {
            path: "/",
            component: MainView,
            meta: { title: `${rootTitle} - Users` },
            redirect: "/users",
            children: [
                // {
                // 	path: '/dashboard',
                // 	name: 'Dashboard',
                // 	component: DashboardContainer,
                // 	meta: {
                // 		title: `${rootTitle} - Dashboard`,
                // 		isAuthRequired: true,
                // 		isPasswordRequired: true
                // 	}
                // },
                {
                    path: "/users",
                    component: UsersView,
                    meta: {
                        title: `${rootTitle} - Users`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Users",
                            component: UsersContainer,
                            meta: {
                                title: `${rootTitle} - Users`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/users/user/:id",
                            name: "View User",
                            component: UserViewComponent,
                            meta: {
                                title: `${rootTitle} - View User`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/users/walker-sitter/:id",
                            name: "View User",
                            component: UserViewComponent,
                            meta: {
                                title: `${rootTitle} - View Walker and Sitter`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/users/store-credit-list",
                            name: "Store Credit List",
                            component: StoreCreditListContainer,
                            meta: {
                                title: `${rootTitle} - Store Credit List`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // products
                {
                    path: "/products",
                    component: ProductsView,
                    meta: {
                        title: `${rootTitle} - Products`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Products",
                            component: ProductsContainer,
                            meta: {
                                title: `${rootTitle} - Products`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/products/batch",
                            name: "Batch Products",
                            component: BatchProductContainer,
                            meta: {
                                title: `${rootTitle} - Batch Products`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/products/add",
                            name: "Add Product",
                            component: AddEditProductComponent,
                            meta: {
                                title: `${rootTitle} - Add Product`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/products/edit/:id",
                            name: "Edit Product",
                            component: AddEditProductComponent,
                            meta: {
                                title: `${rootTitle} - Edit Product`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/products/copy/:id",
                            name: "Copy Product",
                            component: AddEditProductComponent,
                            meta: {
                                title: `${rootTitle} - Add Product`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // brands
                {
                    path: "/brands",
                    component: BrandsView,
                    meta: {
                        title: `${rootTitle} - Brands`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Brands",
                            component: BrandsContainer,
                            meta: {
                                title: `${rootTitle} - Brands`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // bundles
                {
                    path: "/doggy-packs",
                    component: BundlesView,
                    meta: {
                        title: `${rootTitle} - Doggy Packs`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Doggy Packs",
                            component: BundlesContainer,
                            meta: {
                                title: `${rootTitle} - Doggy Packs`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/doggy-packs/add",
                            name: "Add Doggy Pack",
                            component: AddEditBundleComponent,
                            meta: {
                                title: `${rootTitle} - Add Doggy Pack`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/doggy-packs/edit/:id",
                            name: "Edit Doggy Pack",
                            component: AddEditBundleComponent,
                            meta: {
                                title: `${rootTitle} - Edit Doggy Pack`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/doggy-packs/copy/:id",
                            name: "Copy Doggy Pack",
                            component: AddEditBundleComponent,
                            meta: {
                                title: `${rootTitle} - Add Doggy Pack`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // dog purchase
                {
                    path: "/dog-purchase",
                    component: DogPurchaseView,
                    meta: {
                        title: `${rootTitle} - Dog Purchase`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Dog Purchase",
                            component: DogPurchaseContainer,
                            meta: {
                                title: `${rootTitle} - Dog Purchase`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/dog-purchase/request/:id",
                            name: "Dog Orders Info",
                            component: DogPurchaseDetails,
                            meta: {
                                title: `${rootTitle} - Dog  Orders Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/dog-purchase/view/:id",
                            name: "Dog Orders View",
                            component: DogPurchaseDetails,
                            meta: {
                                title: `${rootTitle} - Dog  Orders Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // tracking
                {
                    path: "/tracking",
                    name: "Tracking",
                    component: TrackingContainer,
                    meta: {
                        title: `${rootTitle} - Tracking`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                },
                {
                    path: "/tracking/:id",
                    name: "Track Device",
                    component: TrackDeviceContainer,
                    meta: {
                        title: `${rootTitle} - Track Device`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                },
                {
                    path: "/audit-trail",
                    name: "Audit Trail",
                    component: AuditTrailContainer,
                    meta: {
                        title: `${rootTitle} - Audit Trail`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                },
                // Social
                {
                    path: "/social",
                    component: SocialView,
                    meta: {
                        title: `${rootTitle} - Social Club`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Social Clubs",
                            component: SocialClubContainer,
                            meta: {
                                title: `${rootTitle} - Social Club`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/social/members",
                            name: "Social Clubs - Members",
                            component: SocialClubUsersContainer,
                            meta: {
                                title: `${rootTitle} - Social Club Members`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/social/club/:groupId",
                            name: "Social Clubs - Preview Club",
                            component: SocialViewClubContainer,
                            meta: {
                                title: `${rootTitle} - Preview Social Club`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // Orders
                {
                    path: "/orders",
                    component: OrdersView,
                    meta: {
                        title: `${rootTitle} - Orders`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Orders",
                            component: OrdersContainer,
                            meta: {
                                title: `${rootTitle} - Orders`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/orders/:orderId/view",
                            name: "Orders Details",
                            component: OrdersDetailsContainer,
                            meta: {
                                title: `${rootTitle} - Orders Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // Notifications
                {
                    path: "/notifications",
                    component: NotificationsView,
                    meta: {
                        title: `${rootTitle} - Notifications`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Notification",
                            component: NotificationContainer,
                            meta: {
                                title: `${rootTitle} - Notifications`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/notifications/send",
                            name: "Send Notification",
                            component: NotificationSendComponent,
                            meta: {
                                title: `${rootTitle} - Send Notification`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/notifications/copy/:id",
                            name: "Copy Notification",
                            component: NotificationSendComponent,
                            meta: {
                                title: `${rootTitle} - Copy Notification`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // Subscriptions
                {
                    path: "/subscriptions",
                    component: SubscriptionView,
                    meta: {
                        title: `${rootTitle} - Subscriptions`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Subscriptions Management",
                            component: SubscriptionsManagementContainer,
                            meta: {
                                title: `${rootTitle} - Subscriptions`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/subscriptions/details/:subscriptionId",
                            name: "Subscription Details",
                            component: SubscriptionDetailsPageContainer,
                            meta: {
                                title: `${rootTitle} - Subscriptions`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // Treatments
                {
                    path: "/treatments",
                    component: TreatmentsView,
                    meta: {
                        title: `${rootTitle} - Treatments`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Treatments Management",
                            component: TreatmentsManagementContainer,
                            meta: {
                                title: `${rootTitle} - Treatments`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },

                // Dog Orders
                {
                    path: "/dog-orders",
                    component: DogOrdersView,
                    meta: {
                        title: `${rootTitle} - Dog Orders`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Dog Orders",
                            component: DogOrdersContainer,
                            meta: {
                                title: `${rootTitle} - Dog Orders`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/dog-orders/pending",
                            name: "Pending Dog Orders",
                            component: DogPendingOrdersContainer,
                            meta: {
                                title: `${rootTitle} - Pending Orders`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/dog-orders/:orderId/view",
                            name: "Dog Orders Details",
                            component: DogOrdersDetailsContainer,
                            meta: {
                                title: `${rootTitle} - Orders Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                //Breeders
                {
                    path: "/breeder-management",
                    component: BreedersView,
                    meta: {
                        title: `${rootTitle} - Breeder Management`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Breeder Management",
                            component: BreedersContainer,
                            meta: {
                                title: `${rootTitle} - Breeder Management`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: ":id/view",
                            name: "Breeder Details",
                            component: BreederDetailsContainer,
                            meta: {
                                title: `${rootTitle} - Breeder Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: ":id/breeder-bio",
                            name: "Breeder Bio",
                            component: BreederBioFormContainer,
                            meta: {
                                title: `${rootTitle} - Breeder Bio`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "add",
                            name: "Add Breeder",
                            component: BreederAddContainer,
                            meta: {
                                title: `${rootTitle} - Add Breeder`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "dam-sire/:breederSysId/:id",
                            name: "Dam/Sire Details",
                            component: BreederDamSireDetails,
                            meta: {
                                title: `${rootTitle} - Dam/Sire Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "dam-sire/documents/:breederSysId/:damSireId",
                            name: "Dam/Sire Documents",
                            component: BreederDamSireDocuments,
                            meta: {
                                title: `${rootTitle} - Dam/Sire Documents`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "mating-details/:breederSysId/:id",
                            name: "Mating Details",
                            component: BreederMatingDetails,
                            meta: {
                                title: `${rootTitle} - Mating Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "litter-puppy-list/:breederSysId/:matingId",
                            name: "Litter Puppy List",
                            component: LitterPuppyListDetails,
                            meta: {
                                title: `${rootTitle} - Litter Puppy List`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: ":breederSysId/:id/gestation-period",
                            name: "Gestation Period",
                            component: BreederGestationPeriodContainer,
                            meta: {
                                title: `${rootTitle} - Gestation Period`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "breeder-edit-litter-component/:breederSysId/:matingId/:litterId",
                            name: "Breeder Edit Litter Puppy",
                            component: BreederEditLitterComponent,
                            meta: {
                                title: `${rootTitle} - Edit Litter Puppy`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },

                // Breeds
                {
                    path: "/breed-management",
                    component: BreedsView,
                    meta: {
                        title: `${rootTitle} - Breed Management`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Breed Management",
                            component: BreedsContainer,
                            meta: {
                                title: `${rootTitle} - Breed Management`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/breed-management/add",
                            name: "Add Breed",
                            component: BreedAddEditComponent,
                            meta: {
                                title: `${rootTitle} - Add Breed`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/breed-management/edit/:id",
                            name: "Edit Breed",
                            component: BreedAddEditComponent,
                            meta: {
                                title: `${rootTitle} - Edit Breed`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/breed-management/copy/:id",
                            name: "Copy Breed",
                            component: BreedAddEditComponent,
                            meta: {
                                title: `${rootTitle} - Copy Breed`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // Admin Notifications
                {
                    path: "/admin-notifications",
                    component: NotificationsView,
                    meta: {
                        title: `${rootTitle} - My Notifications`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "My Notification",
                            component: AdminNotificationContainer,
                            meta: {
                                title: `${rootTitle} - My Notifications`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                // Puppy selling
                {
                    path: "/pet-purchases/puppy-selling",
                    component: PuppySellingView,
                    meta: {
                        title: `${rootTitle} - Puppy Selling`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    },
                    children: [
                        {
                            path: "/",
                            name: "Puppy Selling",
                            component: PuppySellingListContainer,
                            meta: {
                                title: `${rootTitle} - Puppy Selling`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/pet-purchases/puppy-payment",
                            name: "Puppy Selling Details",
                            component: PuppyPaymentListContainer,
                            meta: {
                                title: `${rootTitle} - Puppy Payment List`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/pet-purchases/puppy-payment/:id/details",
                            name: "Puppy Payment Details",
                            component: BreederUpdatePuppyPaymentContainer,
                            meta: {
                                title: `${rootTitle} - Puppy Payment Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                        {
                            path: "/pet-purchases/puppy-selling/:id/view",
                            name: "Puppy Selling Details",
                            component: PuppySellingDetailsContainer,
                            meta: {
                                title: `${rootTitle} - Puppy Selling Details`,
                                isAuthRequired: true,
                                isPasswordRequired: true,
                            },
                        },
                    ],
                },
                {
                    path: "/pet-purchases",
                    component: PetPurchasesView,
                    meta: {
                        title: `${rootTitle} - Puppies for Sale`,
                        isAuthRequired: true,
                        isPasswordRequired: true,
                    }
                },
            ],
        },
        // error
        {
            path: "*",
            name: "ErrorView",
            component: ErrorView,
            meta: {
                title: `${rootTitle} - Page Not Found`,
                isGloballyAccessible: true,
            },
        },
    ],
});
